import * as React from 'react';

// #region Component Props

interface IProps {
    columns         : number;
    message         : string;
    icon?           : string;
    transparent?    : boolean;
}

// #endregion 

const EmptyTable : React.SFC<IProps> = props => {

    const { columns, message, icon, transparent } = props;
    return <tr key="aweffaw" className="empty-table-item">
        <td colSpan={ columns } className={"empty-table-row " + (transparent ? 'transparent' : '')}>
            { message }
            <br/>
            <i className={'la ' + (icon ? icon : 'la-search' )} />
        </td>
    </tr> 
}

EmptyTable.defaultProps = {
    icon: 'la-search',
    transparent: false
}

export { EmptyTable }